<template>
	<section class="com-b-wrap">
<!--		<div class="com-title">-->
<!--      <span class="bd"></span>标准产品收益-->
<!--    </div>-->
		<div class="com-table-wrap" style="padding-top: 15px">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px; text-align: left;">
				<el-form :inline="true" :model="queryParam">
					<el-form-item>
						<p>筛选条件：</p>
					</el-form-item>
					<el-form-item>
						<el-input v-model="queryParam.name" placeholder="用户名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParam.consumeTime" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
						 value-format="yyyy-MM-dd" :picker-options="{shortcuts: [
			                    {text: '最近一周', onClick(picker) {
			                        const end = new Date();
			                        const start = new Date();
			                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			                        picker.$emit('pick', [start, end]);
			                      }
			                    },
			                    {text: '最近一个月', onClick(picker) {
			                        const end = new Date();
			                        const start = new Date();
			                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			                        picker.$emit('pick', [start, end]);
			                      }
			                    },
			                    { text: '最近三个月', onClick(picker) {
			                        const end = new Date();
			                        const start = new Date();
			                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			                        picker.$emit('pick', [start, end]);
			                      }
			                    }] }">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-on:click="queryList()">查询</el-button>
					</el-form-item>
<!-- 
					<div class='profit'><img src="../../../static/img/icon-profit.png" />当前总收益<span>{{incomeTotal | money}}</span></div> -->
				</el-form>
			</el-col>

			<el-table :data="pageListData" v-loading="loading" highlight-current-row style="width: 100%" size="medium"
			 row-class-name="listRow" @selection-change="handleSelectionChange">
				<!-- <el-table-column header-align="center" align="center" type="selection" width="55"></el-table-column> -->
				<el-table-column header-align="center" align="center" prop="name" label="名称"></el-table-column>
				<el-table-column header-align="center" align="center" prop="account" label="用户账户"></el-table-column>
				<el-table-column header-align="center" align="center" prop="inviterName" label="推广来源"></el-table-column>
				<el-table-column header-align="center" align="center" prop="payTime" label="下单时间">
					<template slot-scope="scope">{{scope.row.payTime | formatDateTime}}</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="money" label="订单金额">
				</el-table-column>
			</el-table>

			<div class="pagination-block" style="text-align: right;padding: 30px;">
				<el-pagination v-if="paged.total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange" :total="paged.total"
				 :current-page.sync="paged.page" :page-size="paged.pageSize" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper">
				</el-pagination>
			</div>

		</div>

	</section>
</template>

<script>
	import http from '@/http'

	export default {
		data() {
			return {
				queryParam: {
					name:'',
					consumeTime:[]
				},
				inviterOptions: [],
				paged: {
					page: 1,
					pageSize: 10
				},
				pageListData: [],
				loading: false,
				incomeTotal: 0,
			}
		},
		mounted() {
			this.queryList();
		},
		methods: {
			handleSelectionChange: function(val) {
				console.log(val)
			},
			handleCurrentChange: function(val) {
				this.paged.page = val;
				this.queryList();
			},
			handleSizeChange: function(val) {
				this.paged.pageSize = val;
				this.queryList();
			},
			selectClickObj: function(val) {
				var _this = this;
				if (_this.inviterOptions.length < 1) {
					return _this.inviterOptions;
				} else {
					var list = _this.inviterOptions;
					var i = 0;
					while (val && val.length && i < val.length) {
						for (var j = 0; j < list.length; j++) {
							if (list[j].userId == val[i]) {
								if (i == val.length - 1) {
									return list[j];
								} else {
									list = list[j].children;
								}
							}
						}
						i++;
					}
				}
				return null;
			},
			queryList: function() {
				var _this = this;
				_this.loading = true;
				if (_this.queryParam.userIds && _this.queryParam.userIds.length > 0) {
					_this.queryParam.userId = _this.queryParam.userIds[_this.queryParam.userIds.length - 1];
				} else {
					_this.queryParam.userId = null;
				}
				if (_this.queryParam.consumeTime && _this.queryParam.consumeTime.length == 2) {
					_this.queryParam.payTimeStart = _this.queryParam.consumeTime[0];
					_this.queryParam.payTimeEnd = _this.queryParam.consumeTime[1];
				} else {
					_this.queryParam.payTimeStart = null;
					_this.queryParam.payTimeEnd = null;
				}
				var merge = require('webpack-merge');
				var param = merge({}, _this.$route.query, _this.queryParam, _this.paged);
				console.log(param)
				http.post(_this.globalConfig.domain.backstage + "/admin/queryUserPayInfo", param, (response) => {
					let result = response.data;
					if (result.success) {
						_this.pageListData = result.data.listData;
						_this.paged = result.data.paged;
						if (_this.pageListData.length > 0) {
							_this.queryTotalData(param);
						} else {
							_this.incomeTotal = 0;
						}
					} else {
						_this.$message.error(result.message);
					}
					_this.loading = false;
				});
			},
			queryTotalData: function(param) {
				var _this = this;
				http.post(_this.globalConfig.domain.backstage + "/settle/querySettleTotal", param, (response) => {
					let result = response.data;
					if (result.success) {
						_this.incomeTotal = result.data.incomeTotal
					} else {
						_this.$message.error(result.message);
					}
					_this.loading = false;
				});
			},

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /deep/ .el-pager li.active{
    border: 1px solid #00B1FF;
  }
  /deep/ .el-pager li{
    border: 1px solid rgba(2, 47, 74, 0.25098039215686274);
    margin-right: 10px;
  }
  /deep/ .el-pagination .btn-prev{
    border: 1px solid rgba(2, 47, 74, 0.25098039215686274);
    margin-right: 10px;
  }
  /deep/ .el-pagination .btn-next{
    border: 1px solid rgba(2, 47, 74, 0.25098039215686274);
    margin-right: 10px;
  }
  /deep/.el-pager li.active+li{
    border-left: 1;
  }
	.listRow {
		height: 60px;
	}

	.profit {
		float: right;
		background: rgba(252, 237, 230, 0.73);
		font-size: 16px;
		font-family: PingFang SC;
		color: #022F4A;
		width: 300px;
		text-align: left;
		border-radius: 15px;
		line-height: 30px;
		padding: 0 15px;
		box-sizing: border-box;

		img {
			width: 15px;
			height: 15px;
			margin-right: 10px;
			vertical-align: middle;
		}

		span {
			margin-left: 5px;
			font-size: 18px;
			font-family: Arial;
			font-weight: bold;
			color: rgba(249, 153, 0, 1);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/pages/MyProfit.vue